module.exports = __webpack_public_path__ + "img/about1.21d354c.jpg";